var bighouse = bighouse || {};

bighouse.bookingPanel = (function () {

    var superControlUrl = "//secure.supercontrol.co.uk/avail_ajax/js/load.js";
    var scriptId = "bhe_supercontrol";
    var houseData = {
        'ownerID' : '',
        'siteID' : '',
        'cottageID' : '',
        'pricetype' : ''
    };
    var compareBtn = false;


    /* Initialising
       ========================================================================== */

    function init() {

        setTheUserAgent();

        $('.Tooltip').click(function(e){
            $(this).addClass('focus');
            e.preventDefault();
        });

        $('.Tooltip').on('blur', function(e){
            $(this).removeClass('focus');
        });

        $('.Tooltip').on('mouseover', function(e){
            $('.Tooltip.focus').not(this).removeClass('focus');
        });

        initAvailabilityCalendar();
    }



    /**  I am so sorry. 
     * Supercontrol inserts an iframe if the device is a mobile.  
     * This breaks our booking flow and style. 
     * Therefore set the agent to be not a mobile for certain pages so an iframe isn't injected 
     * **/

    function setTheUserAgent(){
        var isSCMobile = detectSCMobile(navigator.userAgent, navigator.vendor, window.opera);

        //console.log('isSCMobile: ' + isSCMobile);
        //console.log('$('.js-houseBuildingSelect').length: ' + $('.js-houseBuildingSelect').length);

        if(isSCMobile && ($('.js-houseArrivalSelect').length > 0  || $('#drawerAvailability').length > 0 ) ){
            setUserAgent(window, "Chrome/51.0.2704.64 Safari/537.362");
        }
    }




    function detectSCMobile(sUserAgent, sVendor, sOpera) {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(sUserAgent || sVendor || sOpera);
        return check;
    }
    


    function setUserAgent(window, userAgent) {
        // Works on Firefox, Chrome, Opera and IE9+
        if (navigator.__defineGetter__) {
            navigator.__defineGetter__('userAgent', function () {
                return userAgent;
            });
        } else if (Object.defineProperty) {
            Object.defineProperty(navigator, 'userAgent', {
                get: function () {
                    return userAgent;
                }
            });
        }
        // Works on Safari
        if (window.navigator.userAgent !== userAgent) {
            var userAgentProp = {
                get: function () {
                    return userAgent;
                }
            };
            try {
                Object.defineProperty(window.navigator, 'userAgent', userAgentProp);
            } catch (e) {
                window.navigator = Object.create(navigator, {
                    userAgent: userAgentProp
                });
            }
        }
    } 



    function initAvailabilityCalendar(){
        if( $('#supercontrol-availability').length === 0 ){
            return;
        }

        //init the onchange
        //get the currently selected code
        //load the current availability calendar based off the hidden vars
        //bind the click and hovers

        initHouseData();
        loadSuperControl();
        bindCalendarEventsOnce();
        buildingSelection();
        removeCalendarPopupLoader();
    }
    

    function initHouseData(){
        houseData.ownerID = $('#bhe_sc_ownerID').val();
        houseData.siteID = $('#bhe_sc_siteID').val();
        houseData.pricetype = $('#bhe_sc_pricetype').val();
    }


    /* Loading and Changing Super Control Scripts
       ========================================================================== */

    function buildingSelection(){
        $('.js-houseBuildingSelect').on('change', function(){
            //update both dropdowns accordingly
            let selectedVal = $(this).val();
            let selectedId = $(this).attr('id');
 
            $('.js-houseBuildingSelect').not('#' + selectedId).val(selectedVal);
 
            var selected = $(this).find('option:selected');
            var newTotal = selected.attr('data-total'); 
            var newPP = selected.attr('data-pp');
            var newName =  selected.text().split('(')[0].trim();

            $('.js-houseTotal').html(newTotal);
            $('.js-housePP').html(newPP);

            $('.js-houseChoice').html(newName);
            //delete current script
            //get new value
            //create new script and load
            removeScript(scriptId);
            loadSuperControl();
        });
    }




    //loads the SC script
    function loadSuperControl(){
        
        //add loader
        $(".Availability-overlay").addClass("Availability-overlay--loading");

        if($('.js-houseBuildingSelect').length > 0){
            houseData.cottageID = $('.js-houseBuildingSelect').first().val();
            houseData.umbracoPropertyId = $('.js-houseBuildingSelect').find('option:selected').attr('data-umbracoPropertyId');
        } else {
            houseData.cottageID = $('#bhe_sc_cottageID').val();
            houseData.umbracoPropertyId = $('#bhe_sc_umbracoPropertyId').val();
        }

        let newScriptUrl = superControlUrl + "?ownerID=" + houseData.ownerID + "&siteID=" + houseData.siteID + "&cottageID=" + houseData.cottageID;


        loadScript(newScriptUrl, scriptId, bindCalendarEvents);
    }


    function removeScript(id){

        if( $('#' + id).length > 0 ){
            var elem = document.querySelector('#' + id);
            elem.parentNode.removeChild(elem);
        }
    }


    function loadScript( url, id, callback ) {
        var script = document.createElement( "script" )
        script.type = "text/javascript";
        script.id = id;
        if(script.readyState) {  // only required for IE <9
          script.onreadystatechange = function() {
            if ( script.readyState === "loaded" || script.readyState === "complete" ) {
              script.onreadystatechange = null;
              callback();
            }
          };
        } else {  //Others
          script.onload = function() {
            callback();
          };
        }
      
        script.src = url;
        document.getElementsByTagName( "head" )[0].appendChild( script );
    }



    /* Dirty Hacky Changes to Calendar
       ========================================================================== */

    function bindCalendarEvents(){


        $(".supercontrol-availability-avail_calendar").ready(function(){


            $(this).off('click'); //remove previous bindings

            //The hackiest function I have ever written. Awful & slow  - can't directly target the ones i want
            $(this).on('click', function(e){

                var triggerBinding = $(e.target).parents('td').attr('onclick');
                if(triggerBinding !== undefined  ){
                    //$('#supercontrol_avail_ajax_results_box').addClass('Availability-loading');
                    setTimeout(function(){
                        checkDropdownExists(0);
                    },500);
                } 



                var clickableTD = $(e.target).parents('td[class$="_y"]');
                if(clickableTD.length > 0){
                    $('.activeDate').removeClass('activeDate');
                    $(clickableTD).addClass('activeDate');
                }

            });


        });

        setTimeout( ()=>{
            if( $('#supercontrol-availability iframe').length > 0 ){
                let callToBook = '';
                
                try{
                    callToBook = '<br/>Please call to book on ' + $('.BookingPanel-phoneno')[0].outerHTML;
                } catch(err){


                }
                //let callToBook = $('.BookingPanel-phoneno')[0].outerHTML;
                //in case the prevention of the iframe insertion occurs, provide user with alternative way to book
                $('#supercontrol-availability').prepend('<p class="Availabilty-error">Sorry, an error has occured.' + callToBook + '</p>');
            }
        }, 1000 );
    }


    function checkDropdownExists(timeoutCounter){
        var dropdownExists = $('#supercontrol_avail_ajax_aa_numbernights' ).length;
        timeoutCounter += 100;
        
       
        if(dropdownExists){
            //dropdown exists
            //$('#supercontrol_avail_ajax_results_box').removeClass('Availability-loading');
            $('#supercontrol_avail_ajax_aa_numbernights').on('change', showCompareButton);
        } else if(timeoutCounter < 2000) {
            setTimeout(function(){
                checkDropdownExists(timeoutCounter);
            }, 100);
        } else {
            //timed out / no dropdown
            //$('#supercontrol_avail_ajax_results_box').removeClass('Availability-loading');
        }
    }

    function bindCalendarEventsOnce(){
        $('.js-lightboxCloseAvailability').on('click', function(){
            //supercontrol_avail_ajax_ClearDates();
            //clear super control

            removeScript(scriptId);
            loadSuperControl();
        });
    }



    function showCompareButton() {

        
        var priceTableExists = $("#price_table").length;

        if(priceTableExists){
            ///booking/compare-confirm-dates?propertyId=1158&datefrom=2019-09-22&nights=1&pricetype=weekrate

            let date = getDates();
            let bookingUrl = '/booking/compare-confirm-dates?propertyId=' + houseData.umbracoPropertyId + '&datefrom=' + date.fromformat + '&nights=' + date.duration + '&pricetype=' + houseData.pricetype;
            
            var clearMarkup = '<td align="center" colspan="2"><a href="javascript:;" onclick="supercontrol_avail_ajax_ClearDates();" class="supercontrol-availability-sc_clear_dates">Clear dates</a></td> ';
            var btnMarkup = '<td align="center" colspan="2"><a href="' + bookingUrl + '" class="Button js-compareSCBtn">Compare prices & book</a></td>';
           
            $("#price_table .sc_tr_cls_btn").first().html(clearMarkup);
            $("#price_table .sc_tr_cls_btn").first().before(btnMarkup);

            $('.js-compareSCBtn').on('click', (e) => {
                $('.js-compareSCBtn').prop('disabled', true);
                $('.Availability-overlay').addClass('Availability-overlay--loading');
            });
        } else {
            // call the function again after 100 milliseconds
            setTimeout(showCompareButton, 100);
        }
    }

    /* Set mutation observer to remove loader as calendar show callback
       ========================================================================== */
    function removeCalendarPopupLoader() {
        if($("#supercontrol-availability").length > 0 && $(".Availability-overlay").length) {

            const targetNode = document.getElementById('supercontrol-availability');

            // Options for the observer (which mutations to observe)
            const config = { attributes: true, childList: true, subtree: true };
            // Callback function to execute when mutations are observed
            const callback = (mutationList, observer) => {
                if($(".supercontrol-availability-avail_calendar").length > 0) {
                    $(".Availability-overlay").removeClass("Availability-overlay--loading");
                }
            };
    
            // Create an observer instance linked to the callback function
            const observer = new MutationObserver(callback);
            // Start observing the target node for configured mutations
            observer.observe(targetNode, config);
        }
    }


    /* Getting and Formatting House Availability Data 
       ========================================================================== */

    function getDates(){

        var fromDate, fromDateFormated, nights;

        if( $('#tr_arrival').is(":visible") ) {
            fromDate = $('#tr_arrival .date_field').html();
        }

        if(fromDate !== undefined){
            fromDateFormated = formatDate(fromDate);
        }

        nights = $('#price_table .date_field').html();

        return {
            "from" : fromDate,
            "fromformat" : fromDateFormated,
            "duration" : nights
        }
    }


    //takes a date Fri 28 Jun 2019 and returns 2019-06-28
    function formatDate(date){
        var dateSplit = date.split(' ');
        var month = dateSplit[2].toLowerCase();

        var formattedMonth = '' + ( dateArray.indexOf(month) + 1);
        if (formattedMonth.length < 2)
            formattedMonth = '0' + formattedMonth;
       
        return dateSplit[3] + '-' + formattedMonth + '-' + dateSplit[1];
    }

    const dateArray = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    


    return {
        init: init
    };
})();

//.a_a_y .diaggradientback, .a_as_y .diaggradientback, .a__y .diaggradientback { 
    //as_b_y
    //b_as_y
    //a_b_y
    //b_a_y
    //bp_a_y
    //.a_a_y, .a_as_y, .a__y { cursor: pointer; }
//.as_as_y, .as_a_y, .as__y { cursor: pointer; }


/* 

.a_a_y,
.as_as_y,
.a__y,
.as_as_y,
.as_a_y,
.as__y,
.a_as_y,
.as_b_y,
.b_as_y,
.a_b_y,
.b_a_y,
.as_bp_y:hover, .as_bp_y:hover .diaggradientfront:hover, .as_bp_y:hover div.calendar_date, .as_bp_y:hover div.dailyprice,
.bp_as_y:hover, .bp_as_y:hover .diaggradientfront:hover, .bp_as_y:hover div.calendar_date, .bp_as_y:hover div.dailyprice,
.a_bp_y:hover, .a_bp_y:hover .diaggradientfront:hover, .a_bp_y:hover div.calendar_date, .a_bp_y:hover div.dailyprice,
.bp_a_y:hover, .bp_a_y:hover .diaggradientfront:hover, .bp_a_y:hover div.calendar_date, .bp_a_y:hover div.dailyprice


*/